(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9443],{

/***/ 89443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ cms_CMS_BannerSmall; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/use-media/lib/index.js
var lib = __webpack_require__(81145);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Image/index.js
var Image = __webpack_require__(4740);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Badge/index.js + 1 modules
var Badge = __webpack_require__(68113);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/molecules/BannerSmall/BannerSmall.module.scss
var BannerSmall_module = __webpack_require__(53516);
var BannerSmall_module_default = /*#__PURE__*/__webpack_require__.n(BannerSmall_module);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/BannerSmall/BannerSmall.jsx








var Title = function(param) {
    var children = param.children, isH1 = param.isH1, className = param.className;
    return isH1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
        className: className,
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: className,
        children: children
    });
};
var BannerSmall = function(param) {
    var banner = param.banner;
    var isMobile = (0,lib/* default */.ZP)({
        maxWidth: 640
    });
    var alignment = banner.alignment, image = banner.image, title = banner.title, is_h1 = banner.is_h1, content = banner.content, link = banner.link, text_color = banner.text_color;
    var center = alignment === "center";
    var left = alignment === "left";
    var right = alignment === "right";
    var bannerClass = classnames_default()("w-full flex bg-cover bg-no-repeat bg-center relative", (BannerSmall_module_default()).banner, {
        "justify-center items-center": center && !isMobile,
        "justify-start items-center": left && !isMobile,
        "justify-end items-center": right && !isMobile,
        "justify-center items-end": isMobile
    });
    var bannerInnerClass = classnames_default()({
        "w-[600px] rounded-xl py-8 px-10": !isMobile,
        "text-center": center,
        "text-left": left,
        "text-right": right,
        "p-6 w-full rounded-tl-xl rounded-tr-xl rounded-b-none bg-opacity-90": isMobile
    });
    var titleClass = classnames_default()("font-heading font-body-normal", {
        "text-h2 mb-2": !isMobile,
        "text-h3 mb-0": isMobile
    });
    var badgeClass = classnames_default()("absolute right-0", {
        "top-0 text-caption": isMobile,
        "bottom-0": !isMobile
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: bannerClass,
        style: {
            height: !isMobile ? "150px" : "100px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "-z-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: title,
                    src: image,
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "center",
                    quality: 70
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: bannerInnerClass,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        className: titleClass,
                        style: {
                            color: text_color ? text_color : "#000000"
                        },
                        isH1: is_h1,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            color: text_color ? text_color : "#000000"
                        },
                        dangerouslySetInnerHTML: {
                            __html: content
                        }
                    })
                ]
            }),
            link.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                className: badgeClass,
                type: isMobile ? "linkTop" : "linkBottom",
                children: link.text
            })
        ]
    });
};
BannerSmall.defaultProps = {};
BannerSmall.propTypes = {
    banner: prop_types.object
};
/* harmony default export */ var BannerSmall_BannerSmall = (BannerSmall);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/BannerSmall/index.js


;// CONCATENATED MODULE: ./components/cms/CMS_BannerSmall.js




var CMS_BannerSmall = function(param) {
    var content = param.content;
    if (!content) return "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSmall_BannerSmall, {
        banner: content
    });
};
CMS_BannerSmall.defaultProps = {};
CMS_BannerSmall.propTypes = {
    content: prop_types.object.isRequired
};
/* harmony default export */ var cms_CMS_BannerSmall = (/*#__PURE__*/react.memo(CMS_BannerSmall));


/***/ }),

/***/ 68113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Badge_Badge; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var Link = __webpack_require__(35384);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Badge/Badge.jsx








var Badge = function(param) {
    var className = param.className, bgColor = param.bgColor, textColor = param.textColor, type = param.type, children = param.children, href = param.href, style = param.style;
    var _obj;
    var rootClass = classnames_default()(className, "inline-block font-body", (_obj = {
        "shadow-down text-small rounded-l-none rounded-r-sm px-2 py-1": type === "generic" || type === "initial" || type === "stockout",
        "text-small rounded-xxl px-2 py-1": type === "round",
        "shadow-down text-caption leading-tight border-solid border border-brand-primary-700 rounded-sm px-1 py-0": type === "discount",
        "shadow-down font-body font-body-normal text-small underline rounded-bl-md px-2 py-1 cursor-pointer": type === "linkTop",
        "shadow-down font-body font-body-normal text-small underline rounded-tl-md px-2 py-1 cursor-pointer": type === "linkBottom",
        "bg-brand-secondary-700": !bgColor && type === "generic",
        "bg-ui-success": !bgColor && type === "round",
        "bg-brand-tertiary-500": !bgColor && type === "initial",
        "bg-ui-gray-300": !bgColor && type === "stockout",
        "bg-ui-white": !bgColor && type === "discount"
    }, (0,_define_property/* default */.Z)(_obj, bgColor, bgColor), (0,_define_property/* default */.Z)(_obj, "text-ui-white", !textColor && (type === "generic" || type === "initial" || type === "round")), (0,_define_property/* default */.Z)(_obj, "text-ui-gray-900", !textColor && type === "stockout"), (0,_define_property/* default */.Z)(_obj, "text-brand-primary-700", !textColor && type === "discount"), (0,_define_property/* default */.Z)(_obj, "text-ui-black", !textColor && (type === "linkTop" || type === "linkBottom")), (0,_define_property/* default */.Z)(_obj, "font-body-normal ".concat(textColor), textColor), _obj));
    var colorRGB = "#FDF2F1";
    var colorRGBA = colorRGB + "80";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: rootClass,
        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
            backgroundColor: type === "linkBottom" || type === "linkTop" ? colorRGBA : ""
        }),
        children: type === "linkBottom" || type === "linkTop" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
            href: href,
            children: children
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        })
    });
};
Badge.defaultProps = {
    type: "generic"
};
Badge.propTypes = {
    className: prop_types.string,
    textColor: prop_types.string,
    bgColor: prop_types.string,
    /** Badge variants: intial, stock-out, generic, discount, etc. */ type: prop_types.oneOf([
        "generic",
        "round",
        "initial",
        "stockout",
        "discount",
        "linkTop",
        "linkBottom", 
    ]),
    children: prop_types.string.isRequired,
    href: prop_types.string
};
/* harmony default export */ var Badge_Badge = (Badge);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Badge/index.js



/***/ }),

/***/ 53516:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"BannerSmall_banner__F7o9y"};

/***/ })

}]);